import { Component, inject, OnInit, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CatalogReferenceService } from '../../../shared/services/catalog-reference.service';
import { forkJoin, map, of, switchMap } from 'rxjs';
import { ContestsResponse } from '../../../how-do-i-win/interfaces/contests-response.interface';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-modal-my-progress',
  imports: [DecimalPipe],
  templateUrl: './modal-my-progress.component.html',
})
export class ModalMyProgressComponent implements OnInit {
  private catalogReferenceService = inject(CatalogReferenceService);
  private nbgActiveModal = inject(NgbActiveModal);

  protected contests = signal<ContestsResponse[]>([]);
  protected isLoading = signal(true);

  ngOnInit() {
    this.catalogReferenceService
      .getCatContests()
      .pipe(
        switchMap((catContests) => {
          if (catContests.length === 0) {
            return of([]);
          }

          const request = catContests.map((catContest) =>
            this.catalogReferenceService.getContests(catContest.idValue),
          );

          return forkJoin(request).pipe(map((responses) => responses.flat()));
        }),
      )
      .subscribe({
        next: (response) => {
          this.contests.set(response);
          this.isLoading.set(false);
        },
        error: () => {
          this.isLoading.set(false);
        },
      });
  }

  closeModal() {
    this.nbgActiveModal.close();
  }

  flipCard(card: HTMLElement) {
    card.classList.add('flipped');
  }

  removeFlipCard(card: HTMLElement) {
    card.classList.remove('flipped');
  }

  getProgressWidth(goal: number, progress: number): string {
    if (progress >= goal) {
      return '100%';
    }

    const width = (progress * 100) / goal;
    return `${width}%`;
  }
}
